import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

const styles = {
  container: {
    gap: 1,
    py: 1,
    px: 2,
    '&:not(:last-child)': {
      borderBottom: '1px solid',
      borderColor: 'divider',
    },
  },
  label: {
    color: 'text.secondary',
    fontWeight: 'normal',
    whiteSpace: 'normal',
  },
}

export default function Property({ label, labelWidth = 120, children, sx = {} }) {
  const labelSize = {
    width: labelWidth,
    minWidth: labelWidth,
    flex: `0 0 ${typeof labelWidth === 'number' ? `${labelWidth}px` : labelWidth}`,
  }

  return (
    <Stack direction="row" sx={[styles.container, sx.root]}>
      {label && <Typography sx={[styles.label, labelSize, sx.label]}>{label}</Typography>}
      {['number', 'string'].includes(typeof children) ? <Typography sx={sx.value}>{children}</Typography> : children}
    </Stack>
  )
}

Property.Loading = ({ label, labelWidth, sx }) => (
  <Property label={label} labelWidth={labelWidth} sx={sx}>
    <Typography sx={{ width: '100%' }}>
      <Skeleton />
    </Typography>
  </Property>
)
